// Get the current locale
import { TRANSLATION } from './translations';

export const locale = document.documentElement.lang;

export function t(copy, key, vars) {
  // // Let's throw some errors if we're trying to use keys/locales that don't exist.
  // // We could improve this by using Typescript and/or fallback values.
  if (!key) throw new Error('no key provided to $t()');

  // // Grab the translation from the translations object.
  let text = copy[locale][key];

  if (!text) throw new Error(`no translation found for ${key}`);

  if (key != 'Exceptions') {
    if (vars) {
      // // Replace any passed in variables in the translation string.
      Object.keys(vars).map((k) => {
        const regex = new RegExp(`{${k}}`, 'g');
        text = text.replace(regex, vars[k]);
      });
    }
    return text;
  } else {
    // If t takes an exception, text refers to the exception object, and vars is the city name we are passing in
    return text[vars];
  }
}

//export const t = (locale,($locale) => (key, vars = {}) => translate($locale, key, vars))

//   export const t = derived(locale, ($locale) => (key, vars = {}) =>
//     translate($locale, key, vars)
//   );

// a simple translation function
export function __(text) {
  if (locale == 'en') {
    return text;
  }

  return TRANSLATION[locale][text] || text;
}

export function byLocale(text, col) {
  // console.log('IN THE FUNCTION TEST', text);
  if (locale == 'en') {
    // return text.heading;
    return text[__c(col)];
  }
  return text[__c(col)];
}

export function __c(col) {
  if (locale == 'en') {
    return col;
  }
  return `${col}_es`;
}
